/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
	data() {
		return {
			state: 'loading',
			content: '<div class="mt-ul-empty">Loading…</div>',
			reference: '',
			email: '',
			busy: false,
			loggedIn: false,
			loginUrl: ui_data.homeUrl + '/wp-login.php',
			requestId: 0,
		};
	},
	mounted() {
		this.loadMine();
	},
	methods: {
		request( url, options ) {
			if ( window.fetch ) {
				options = options || {};
				options.credentials = 'same-origin';
				options.cache = 'no-store';

				return fetch( url, options ).then( function ( response ) {
					return response.json();
				} );
			}

			return Promise.reject( new Error( 'fetch unavailable' ) );
		},
		loadMine() {
			const vm = this;
			const id = ++vm.requestId;

			vm.state = 'loading';
			vm.content = '<div class="mt-ul-empty">Loading…</div>';

			vm.request( ui_data.ajaxurl + '?action=mt_lu_modal&_=' + Date.now() )
				.then( function ( response ) {
					if ( id !== vm.requestId ) {
						return;
					}

					const data = response && response.data ? response.data : {};

					vm.loggedIn = !! data.logged_in;

					if ( data.login_url ) {
						vm.loginUrl = data.login_url;
					}

					if ( vm.loggedIn ) {
						vm.state = 'logged-in';
						vm.content = data.html || '<div class="mt-ul-empty">No licenses available for upgrade on your account.</div>';
					} else {
						vm.state = 'guest-search';
						vm.content = '';
					}
				} )
				.catch( function () {
					if ( id !== vm.requestId ) {
						return;
					}

					vm.state = 'guest-search';
					vm.content = '';
				} );
		},
		lookup() {
			const vm = this;
			const id = ++vm.requestId;

			vm.busy = true;
			vm.state = 'guest-results';
			vm.content = '<div class="mt-ul-empty">Searching…</div>';

			const formData = new FormData();

			formData.append( 'action', 'mt_lu_lookup' );
			formData.append( 'ref', vm.reference );
			formData.append( 'email', vm.email );

			vm.request( ui_data.ajaxurl, {
				method: 'POST',
				body: formData,
			} )
				.then( function ( response ) {
					if ( id !== vm.requestId ) {
						return;
					}

					const data = response && response.data ? response.data : {};

					if ( data.html ) {
						vm.content = data.html;
					} else {
						vm.content = '<div class="mt-ul-empty">We couldn’t find an order matching those details.</div>';
					}
				} )
				.catch( function () {
					if ( id !== vm.requestId ) {
						return;
					}

					vm.content = '<div class="mt-ul-empty">Could not load your licenses.</div>';
				} )
				.then( function () {
					if ( id === vm.requestId ) {
						vm.busy = false;
					}
				} );
		},
	},
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upgrade-license-page container"},[_c('div',{attrs:{"id":"mt-upgrade-card","data-state":_vm.state}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mt-upgrade-body"},[_c('div',{staticClass:"mt-upgrade-form-wrapper"},[_c('div',{staticClass:"mt-ul-form-inner"},[_c('div',{staticClass:"mt-ul-side-h"},[_vm._v("Find your order")]),_vm._v(" "),_c('p',{staticClass:"mt-ul-side-p"},[_vm._v("Enter the order number (or purchase key) and the email used at checkout.")]),_vm._v(" "),_c('form',{attrs:{"id":"mt-upgrade-lookup","autocomplete":"off","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.lookup.apply(null, arguments)}}},[_c('div',{staticClass:"mt-ul-inputs"},[_c('div',{staticClass:"mt-ul-field"},[_c('label',{attrs:{"for":"mt-ul-ref"}},[_vm._v("Order number or purchase key")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reference),expression:"reference"}],attrs:{"id":"mt-ul-ref","name":"ref","type":"text","required":""},domProps:{"value":(_vm.reference)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reference=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mt-ul-field"},[_c('label',{attrs:{"for":"mt-ul-email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"mt-ul-email","name":"email","type":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mt-ul-field-btn"},[_c('button',{staticClass:"mt-ul-submit",attrs:{"id":"mt-ul-submit","type":"submit","disabled":_vm.busy}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.busy ? 'Searching…' : 'Find')+"\n\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),(!_vm.loggedIn)?_c('div',{staticClass:"mt-ul-side-alt",attrs:{"id":"mt-ul-alt"}},[_c('span',[_vm._v("or")]),_vm._v(" "),_c('a',{staticClass:"mt-ul-link",attrs:{"href":_vm.loginUrl}},[_vm._v("Log in to see all your orders")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"mt-upgrade-content",attrs:{"id":"mt-upgrade-content"},domProps:{"innerHTML":_vm._s(_vm.content)}})]),_vm._v(" "),_vm._m(1)])])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-upgrade-header"},[_c('h1',{staticClass:"mt-modal-title"},[_vm._v("Upgrade License")]),_vm._v(" "),_c('p',{staticClass:"mt-modal-sub"},[_vm._v("Pay only the difference when you upgrade an existing license.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-upgrade-footer"},[_c('span',{staticClass:"mt-upgrade-note"},[_vm._v("The price you already paid for your current license is credited automatically at checkout. Upgrades are purchased separately from the other beats in your cart.")])])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "UpgradeLicensePage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__